import { render, staticRenderFns } from "./TutorDashboard.vue?vue&type=template&id=0d3be116"
import script from "./TutorDashboard.vue?vue&type=script&lang=js"
export * from "./TutorDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports